"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSettings = exports.IdentificationStrategiesEnum = exports.CalculateOnStepsEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const form_1 = require("./form");
var CalculateOnStepsEnum;
(function (CalculateOnStepsEnum) {
    CalculateOnStepsEnum["PROJECT_STEP_1"] = "project-step-1";
    CalculateOnStepsEnum["PROJECT_STEP_2"] = "project-step-2";
    CalculateOnStepsEnum["PROJECT_STEP_3"] = "project-step-3";
    CalculateOnStepsEnum["PROJECT_STEP_4"] = "project-step-4";
    CalculateOnStepsEnum["PROJECT_STEP_5"] = "project-step-5";
    CalculateOnStepsEnum["PROJECT_STEP_6"] = "project-step-6";
    CalculateOnStepsEnum["PROJECT_STEP_7"] = "project-step-7";
    CalculateOnStepsEnum["PROJECT_STEP_8"] = "project-step-8";
    CalculateOnStepsEnum["PROJECT_STEP_9"] = "project-step-9";
})(CalculateOnStepsEnum = exports.CalculateOnStepsEnum || (exports.CalculateOnStepsEnum = {}));
var IdentificationStrategiesEnum;
(function (IdentificationStrategiesEnum) {
    IdentificationStrategiesEnum["DOMAIN_CODE_CARDNUMBER_ALL_VALIDATED"] = "domain_code_cardnumber_all_validated";
    IdentificationStrategiesEnum["DOMAIN_CODE_ALL_VALIDATED"] = "domain_code_all_validated";
    IdentificationStrategiesEnum["DOMAIN_CODE_ONLYCODE_VALIDATED"] = "domain_code_onlycode_validated";
    IdentificationStrategiesEnum["EMAIL_EID_ALL_VALIDATED"] = "email_eid_all_validated";
    IdentificationStrategiesEnum["EMAIL_ONLY_VALIDATED"] = "email_only_validated";
})(IdentificationStrategiesEnum = exports.IdentificationStrategiesEnum || (exports.IdentificationStrategiesEnum = {}));
let FormSettings = class FormSettings {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)('uuid'),
    __metadata("design:type", String)
], FormSettings.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => form_1.Form, (item) => item.settings),
    (0, typeorm_1.JoinColumn)({
        name: 'form_id',
    }),
    __metadata("design:type", form_1.Form)
], FormSettings.prototype, "form", void 0);
__decorate([
    (0, typeorm_1.Column)('uuid', {
        name: 'form_id',
        nullable: false,
    }),
    __metadata("design:type", String)
], FormSettings.prototype, "formId", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'progress',
        nullable: false,
        default: true,
    }),
    __metadata("design:type", Boolean)
], FormSettings.prototype, "progress", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'price',
        nullable: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], FormSettings.prototype, "price", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
    }),
    __metadata("design:type", Boolean)
], FormSettings.prototype, "priceAffiliate", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'summary',
        nullable: false,
        default: true,
    }),
    __metadata("design:type", Boolean)
], FormSettings.prototype, "summary", void 0);
__decorate([
    (0, typeorm_1.Column)('float', {
        name: 'price_estimate_from',
        nullable: true,
    }),
    __metadata("design:type", Number)
], FormSettings.prototype, "priceEstimateFrom", void 0);
__decorate([
    (0, typeorm_1.Column)('enum', {
        name: 'calculate_on_steps',
        array: true,
        default: `{}`,
        enum: CalculateOnStepsEnum,
    }),
    __metadata("design:type", Array)
], FormSettings.prototype, "calculateOnSteps", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 64,
        name: 'theme',
        nullable: false,
        default: 'default',
    }),
    __metadata("design:type", String)
], FormSettings.prototype, "theme", void 0);
__decorate([
    (0, typeorm_1.Column)('enum', {
        name: 'identification_strategy',
        nullable: true,
        enum: IdentificationStrategiesEnum,
    }),
    __metadata("design:type", String)
], FormSettings.prototype, "identificationStrategy", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => form_1.Form),
    (0, typeorm_1.JoinColumn)({
        name: 'delegated_form_id',
    }),
    __metadata("design:type", form_1.Form)
], FormSettings.prototype, "delegatedForm", void 0);
__decorate([
    (0, typeorm_1.Column)('uuid', {
        name: 'delegated_form_id',
        nullable: true,
    }),
    __metadata("design:type", String)
], FormSettings.prototype, "delegatedFormId", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormSettings.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormSettings.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], FormSettings.prototype, "deletedAt", void 0);
FormSettings = __decorate([
    (0, typeorm_1.Entity)('form_settings', { schema: 'order_intake_forms' })
], FormSettings);
exports.FormSettings = FormSettings;
//# sourceMappingURL=form-settings.js.map